<template>
  <div>
    <div class="line__vertical-mains"></div>
    <!-- <promotion-alert>
        36
    </promotion-alert> -->
    <sub-header :micrositeUrl="micrositeUrl" />
    <div v-if="locations.length > 0" class="map_filter">
      <div class="maphighlight__box">
        <!-- <Promotion class="promotion_mobile">36</Promotion> -->
          <h1 class="caption__select">
                  <span>Seleccione una etapa, clic para ver detalles</span>
                </h1>
        <map-highlight class="paseoparque-pin" v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel" :indicators="indicators"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img" :id="id" :nivel="nivel"  :desarrollo="desarrollo" :levelId="levelId" :url="url"/>
        <div class="line_horizontal"></div>
        <Availables
            class="availables-mobile"
            :amountAvailables="amountAvailables"
            :nivel="nivel"

        />
      </div>
      <div class="select__box" :class="selectHide">
        <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        />
        <Availables
            class="availables-desk"
            :amountAvailables="amountAvailables"
            :nivel="nivel"
        />
        <!-- <Promotion class="promotion_web">36</Promotion> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight.vue";
import Select from "../../core/Select.vue";
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
/* import PromotionAlert from "../../core/PromotionAlert.vue";
import Promotion from "../../core/Promotion.vue"; */
export default {
  name: "Main",
  components: {
    SubHeader,
    MapHighlight,
   /*  PromotionAlert,
    Promotion, */
    Select,
    Availables,
    Button,
  },
  data() {
    return {
      id: 33,
      nivel: "towerStage",
      levelId: 0,
      desarrollo: "paseodelparque",
      arrFilteredLocations: [],
      url: "paseodelparque",
      micrositeUrl: "https://tresmarias.com.mx/paseodelparque/terrenos",
      imgSet: [
        {
          name: 'paseodelparque',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/paseodelparque/Main_PDP.png',
          width: '13119',
          height: '7167',
          id: 33,
          levelId: 0,
          route: 'paseodelparque',
          nivel: 'towerStage',
          transform: '',
          viewBox: '0 0 13119 7167'
        }
      ],
      indicators: [
        //{id: 10, text: 'ETAPA 1', transform: 'matrix(1.0714 0 0 1 870 3100)',cxB: 1370, cyB: 2800, rB: 100, cxW: 1370, cyW: 2800, rW: 50, x1: 1470, y1: 2800, x2: 2570, y2: 2800,  status: true },
        //{id: 11, text: 'ETAPA 2', transform: 'matrix(1.0714 0 0 1 5400 4700)',cxB: 5800, cyB: 4400, rB: 100, cxW: 5800, cyW: 4400, rW: 50, x1: 5900, y1: 4400, x2: 6500, y2: 4300,  status: true },
        //{id: 12, text: 'ETAPA 3', transform: 'matrix(1.0714 0 0 1 6900 5600)',cxB: 7400, cyB: 5300, rB: 100, cxW: 7400, cyW: 5300, rW: 50, x1: 7500, y1: 5300, x2: 8800, y2: 5300,  status: true },
        //{id: 13, text: 'ETAPA 4', transform: 'matrix(1.0714 0 0 1 420 4100)',cxB: 920, cyB: 3800, rB: 100, cxW: 920, cyW: 3800, rW: 50, x1: 1020, y1: 3800, x2: 2020, y2: 3800,  status: true },
        {id: 14, text: 'ETAPA 5', transform: 'matrix(1.0714 0 0 1 8320 1323)',cxB: 8820, cyB: 1056, rB: 100, cxW: 8820, cyW: 1056, rW: 50, x1: 10529, y1: 1076, x2: 8914, y2: 1070,  status: true },
      ],
      // si no hay filtro volver rangeFilter a false
      rangeFilter: false
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      return { id: this.id, level: 0 };
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      return arrExistFilter;
    },
    amountAvailables(){
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.available > 0
      );
      return newArrfiltered;
    },
    selectHide(){
      if(this.rangeFilter == false){
        return 'u__dipslay--none'
      }else{
        return ''
      }
    }
  },
  methods: {
    ...mapActions(["getTowerStage", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.getTowerStage(this.development);
  },
  async beforeDestroy(){
    await this.clearCoords()
  }
};
</script>
<style>
.paseoparque-pin .st2{
  font-size: 20rem;
}
.paseoparque-pin .st3{
  stroke-width: 30;
}
</style>
